import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    style: { "font-size": "14px" }
};
const _hoisted_2 = {
    key: 1,
    class: "mb-3"
};
const _hoisted_3 = { class: "d-flex flex-wrap gap-2" };
const _hoisted_4 = ["id", "value"];
const _hoisted_5 = ["for"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Table = _resolveComponent("Table");
    return (_openBlock(), _createElementBlock("span", null, [
        _cache[2] || (_cache[2] = _createElementVNode("h5", null, "Data: Visible/Selected Molecules", -1)),
        (_ctx.allTableData.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, " No molecules (visible or selected) have data to display. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[1] || (_cache[1] = _createElementVNode("p", {
                    style: { "font-size": "14px" },
                    class: "mb-2"
                }, "Use these toggle buttons to indicate the data to display in the table below:", -1)),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTableData, (tableData) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: tableData[0]
                        }, [
                            _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: `btn-check-${tableData[0]}`,
                                value: tableData[0],
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedSources) = $event)),
                                class: "btn-check",
                                autocomplete: "off"
                            }, null, 8, _hoisted_4), [
                                [_vModelCheckbox, _ctx.selectedSources]
                            ]),
                            _createElementVNode("label", {
                                for: 'btn-check-' + tableData[0],
                                class: "btn btn-outline-primary btn-sm"
                            }, _toDisplayString(tableData[0]), 9, _hoisted_5)
                        ]));
                    }), 128))
                ])
            ])),
        _withDirectives(_createVNode(_component_Table, {
            id: "data-panel-table",
            tableData: _ctx.tableDataForDisplay,
            virtualize: true,
            caption: "All Molecular Data",
            noFixedTable: true,
            onRowClicked: _ctx.rowClicked,
            clickableRows: true,
            downloadFilenameBase: "all-molecular-data",
            allowFilter: true
        }, null, 8, ["tableData", "onRowClicked"]), [
            [_vShow, _ctx.mergedTableData !== null]
        ])
    ]));
}
